module.exports = "<div class=\"editor-wrapper\" ng-model=\"$root.editorValue\" ui-ace=\"{\n  useWrapMode : true,\n  mode: 'yaml',\n  onLoad: aceLoaded,\n  onChange: aceChanged}\">\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./views/editor/editor.html
 ** module id = 282
 ** module chunks = 0
 **/